import { PermissionType } from 'types/entities/permissions.d';
import { PermissionCriteria } from 'types/models/roles.d';
import { PaginationResponseType } from 'types/response.d';
import { get } from './axios';

const url = `/roles/permissions`;

export const filter = (
  request: PermissionCriteria
): Promise<PaginationResponseType<PermissionType[]>> => get(url, { params: { ...request } });
